import React,{useEffect,useContext,useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import { Box,Select, FormControl, InputLabel } from '@material-ui/core'
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {ErrorGeneral , llamaApiCargaToken } from '../funciones/ClienteAxios';

const EstacionSVG = () => {
  const history = useHistory();
  const usu= localStorage.getItem('UsuarioNom');
  const nvl= localStorage.getItem('Tipo');          
  const idusu = localStorage.getItem('UsuId');  
  const source = axios.CancelToken.source();  
  const [datos,setDatos]=useState([])
  const [registro, setRegistro]=useState([])
  const [imagen, setImagen]=useState([])
  const [espera,setEspera]=useState(false)
  const [espera2,setEspera2]=useState(false)
  const {usuario,guardarUsuario}=useContext(AuthContext);
  const {guardarGenerales}=useContext(GeneralesContext);  
 
  useEffect(()=>{               
   
    veriSesion()
    datosBitacora()
   
    return ()=> {
      source.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[])

  const veriSesion =  () => 
  {            
    if(usu===null)
    {                                
      guardarUsuario([])						
      guardarGenerales([])     
      localStorage.clear();           
      history.push("/")	
    }
    else
    { 
      if (usuario.length === 0) 
      {
        guardarUsuario({Nombre:usu,nivel:nvl});                                      
      }
      guardarGenerales({Titulo:'Estacion '})                     
    }
  }

  const datosBitacora=()=>{
     
            
    const data = qs.stringify({    
      Usuario:idusu,                                  
      idDispositivo:'ifrekvjkxcdwdcwe'
    });
    const url = "/estacion/list";
    function respuesta(aux) {
      if (aux[0].length!==0) 
      {                
        setDatos(aux);                                      
      }          
    }

    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  }


  const onChange  = (event) => {
    setRegistro(event.target.value);
    const filtro = datos.filter((dato)=>dato.Id + "" === event.target.value  + "")
    //console.log(filtro,event.target.value);
    
    setImagen(filtro[0])
  };
 
  return (
  <div>            
    <Box display="flex" flexDirection="column">
      <Box display="flex" width="10%" flexDirection="column" mb={2}>
        {datos.length !== 0 ?
          <FormControl   size="small">
            <InputLabel htmlFor="registro-native-simple">Estaciones</InputLabel>
            <Select
              native value={registro} onChange={onChange}
              inputProps={{name: 'registro', id: 'registro'}}
            >
                <option aria-label="None" value=""/>
                {datos.map((row) => (
                  <option value={row.Id}>{row.Nom}</option>
                ))}
            </Select>
          </FormControl>
        : null}
      </Box>
       <Box display="flex" width="90%" flexDirection="column">
        {imagen.length !== 0 ?
          <img src={imagen.Svg} style={{width:"80vw"}}/>
        : null}
      </Box>
    </Box>                        
  </div>
  )
}

export default EstacionSVG